import { render } from "./TimeAccountTab.vue?vue&type=template&id=643311b0"
import script from "./TimeAccountTab.vue?vue&type=script&lang=js"
export * from "./TimeAccountTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__